import { TrackYourSpend } from './TrackYourSpend'
import { View, XStack, YStack } from 'tamagui'
import { DesignSystem } from '@/src/design-system'
import { StatementClose } from './StatementClose'
import { AwardAmount } from './AwardAmount'
import * as MortgageEarn from '@/src/experiences/mortgage-earn'
import { DocumentRequired } from './DocumentRequired'
import { Rejected } from './Rejected'
import { InReview } from './InReview'
import { MortgageRewardsSkeleton } from './Skeleton'
import { withCardGate } from '@/src/experiences/card-accounts/withCardGate'
import { Section } from '../Section'

export const MortgageRewards = withCardGate(function ({
  showCardManagement,
  firstCardFetchFinished,
  refetchApplicationStatus,
}) {
  const mortgageEarnStatus = MortgageEarn.Stores.MortgageEarnApi.endpoints[
    'GET /mortgage/earn'
  ].useQuery({})

  DesignSystem.ScreenWideReload.useReloadListener(async () => {
    await refetchApplicationStatus()
    await mortgageEarnStatus.refetch()
  })

  const { isLoading, error } = mortgageEarnStatus
  const { latestMonthlyAward, activeMonthlyAward, progress } = mortgageEarnStatus.data ?? {}

  const isUploadRequired = latestMonthlyAward?.status === 'UPLOAD_REQUIRED'
  const isRejected = latestMonthlyAward?.status === 'REJECTED'
  const isInReview = latestMonthlyAward?.status === 'PENDING'
  const needsAttention = isUploadRequired || isRejected
  const resolvedNotACardholder = !showCardManagement && firstCardFetchFinished

  if ((!latestMonthlyAward && !isLoading && !error) || resolvedNotACardholder) {
    return null
  }

  if (!latestMonthlyAward || !progress || !firstCardFetchFinished) {
    return <MortgageRewardsSkeleton />
  }

  return (
    <Section
      title="Mortgage Rewards"
      subtitle="Earn 1X Mesa Points on your monthly mortgage payment"
    >
      <YStack gap="$4">
        {isUploadRequired ? <DocumentRequired /> : null}
        {isRejected ? <Rejected /> : null}
        {isInReview ? (
          <InReview
            isUpdate={
              activeMonthlyAward?.awardAmountInPoints !== latestMonthlyAward.awardAmountInPoints
            }
          />
        ) : null}
        <DesignSystem.Card>
          <TrackYourSpend
            spendAmount={progress.statementSpend}
            thresholdAmount={progress.statementSpendThreshold}
          />
        </DesignSystem.Card>
        <XStack gap="$4" justify="space-between">
          {progress.statementCloseDate ? (
            <View grow={1} shrink={1}>
              <StatementClose date={new Date(progress.statementCloseDate)} />
            </View>
          ) : null}
          <View grow={1} shrink={1}>
            <AwardAmount
              amount={
                activeMonthlyAward?.awardAmountInPoints ?? latestMonthlyAward.awardAmountInPoints
              }
              needsAttention={needsAttention}
            />
          </View>
        </XStack>
      </YStack>
    </Section>
  )
})
